//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addMonths } from 'date-fns'
import { formatDate, currency } from '@/plugins/filters'
import FilterModal from '@/components/modal/FilterModal.vue'
import FilterIcon from '@/components/icon/FilterIcon.vue'

export default {
  name: 'OptionRequestPage',

  components: {
    FilterModal,
    FilterIcon,
  },

  layout: 'page',

  data() {
    const { query } = this.$route

    return {
      listLoading: false,
      submitLoading: false,
      previewTab: 'count',
      floor: { id: query.floor },
      deliveryInfo: {
        totalCount: 0,
        tCount: 0,
        pCount: 0,
        oCount: 0,
      },
      tips: '',
      date: addMonths(new Date(), 1),
      dateMax: addMonths(new Date(), 1),
      startDate: null,
      endDate: null,
      catList: [],
      catListMap: [],
      perDeliveryCount: 0,
      deliveryTotal: 0,
      priceTotal: 0,
      employeesPriceTotal: 0,
      billingAmount: 0,
      priceList: [],
      employeesPriceList: [],
      isAdmin: null,
      canRequest: null,
      warnTips: '',
      sorts: [
        {
          name: 'price',
          label: '商品代金',
          type: 'default',
        },
        {
          name: 'employeesPrice',
          label: '従業員購入価格',
          type: 'default',
        },
        {
          name: 'lastMonthDeliveryCount',
          label: '前月の注文数',
          type: 'default',
        },
        {
          name: 'count',
          label: 'ご希望お届け数',
          type: 'default',
        },
      ],
      sortActive: '',
      sortType: 'default',
      lastRequestDatetimeThisMonth: null,
      banners: [],
      // 絞り込み機能（selected: モーダル編集中 / confirmed: 一覧反映済み）
      filterModalVisible: false,
      selectedPrices: [],
      selectedCategories: [],
      confirmedPrices: [],
      confirmedCategories: [],
      modalHitCount: 0,
    }
  },

  head() {
    return {
      bodyAttrs: {
        class: this.$options.name,
      },
    }
  },

  computed: {
    month() {
      return formatDate(this.date, 'yyyy-MM')
    },
    allGoodsList() {
      let list = []

      Object.values(this.catListMap).forEach((item) => {
        list = list.concat(item)
      })

      return list
    },
    filteredGoods() {
      return this.applyFilters(this.allGoodsList, {
        prices: this.confirmedPrices,
        categories: this.confirmedCategories,
      })
    },
    goodsSortList() {
      if (!this.filteredGoods) {
        return []
      }

      const newList = this.filteredGoods.slice()

      if (!this.sortActive) {
        return newList
      }

      return this.handleSort(newList, this.sortActive, this.sortType)
    },
    // 絞り込み表示用
    categoryOptions() {
      return this.catList.map((cat) => ({
        id: cat.catID,
        name: cat.catName,
      }))
    },
    filterConditionCount() {
      return this.confirmedPrices.length + this.confirmedCategories.length
    },
    filterConditionText() {
      const parts = []

      if (this.confirmedPrices.length > 0) {
        const priceText = [...this.confirmedPrices]
          .sort((a, b) => a - b)
          .map((price) => currency(price).replace(/\s/g, ''))
          .join(' or ')
        parts.push(priceText)
      }

      if (this.confirmedCategories.length > 0) {
        const categoryMap = this.catList.reduce((acc, cat, index) => {
          acc[cat.catID] = { name: cat.catName, index }
          return acc
        }, {})

        const categoryText = this.confirmedCategories
          .map((catID) =>
            categoryMap[catID] ? { id: catID, ...categoryMap[catID] } : null
          )
          .filter(Boolean)
          .sort((a, b) => a.index - b.index)
          .map((item) => item.name)
          .join(' or ')
        parts.push(categoryText)
      }

      return parts.join('、')
    },
    isFiltering() {
      return (
        this.confirmedPrices.length > 0 || this.confirmedCategories.length > 0
      )
    },
    goodsPriceList() {
      if (!this.allGoodsList) {
        return []
      }
      return this.allGoodsList
        .reduce((acc, cur) => {
          if (!acc.includes(cur.price)) {
            acc.push(cur.price)
          }

          return acc
        }, [])
        .sort((a, b) => a - b)
    },
    countList() {
      return this.catList.map((item) => {
        let count = 0
        let price = 0
        let employeesPrice = 0

        for (let i = 0; i < item.goodsList.length; i++) {
          const goods = item.goodsList[i]

          count += goods.count
          price += goods.price * goods.count
          employeesPrice += goods.employeesPrice * goods.count
        }

        return {
          name: item.catName,
          text: `${count} 個`,
          count,
          price,
          employeesPrice,
        }
      })
    },
    allowSubmit() {
      if (!this.isAdmin && !this.canRequest) {
        return false
      }

      return true
    },
  },

  watch: {
    countList(newValue) {
      let perDeliveryCount = 0
      let priceTotal = 0
      let employeesPriceTotal = 0

      for (let i = 0; i < newValue.length; i++) {
        const item = newValue[i]

        perDeliveryCount += item.count
        priceTotal += item.price
        employeesPriceTotal += item.employeesPrice
      }

      this.perDeliveryCount = perDeliveryCount
      this.deliveryTotal = this.perDeliveryCount
      this.priceTotal = priceTotal
      this.employeesPriceTotal = employeesPriceTotal
      this.billingAmount = this.priceTotal - this.employeesPriceTotal

      this.priceList = newValue.map((item) => {
        return {
          name: item.name,
          text: currency(item.price),
        }
      })

      this.employeesPriceList = newValue.map((item) => {
        return {
          name: item.name,
          text: currency(item.employeesPrice),
        }
      })
    },
  },

  mounted() {
    this.fetchOptions()
  },

  methods: {
    // 価格・カテゴリ条件で商品リストを絞り込む
    applyFilters(goods, { prices = [], categories = [] }) {
      let filtered = goods

      if (prices.length > 0) {
        filtered = filtered.filter((item) => prices.includes(item.price))
      }

      if (categories.length > 0) {
        filtered = filtered.filter((item) => categories.includes(item.catID))
      }

      return filtered
    },

    // 絞り込みモーダル表示時に、確定済み条件を初期値へ反映して件数を更新
    showFilterModal() {
      const prices = [...this.confirmedPrices]
      const categories = [...this.confirmedCategories]

      this.selectedPrices = prices
      this.selectedCategories = categories
      this.modalHitCount = this.applyFilters(this.allGoodsList, {
        prices,
        categories,
      }).length
      this.filterModalVisible = true
    },
    handleConditionsChange({ prices, categories }) {
      this.selectedPrices = [...prices]
      this.selectedCategories = [...categories]
      this.updateModalHitCount(prices, categories)
    },
    // モーダル内で選択中の条件に一致する商品件数を計算
    updateModalHitCount(prices, categories) {
      this.modalHitCount = this.applyFilters(this.allGoodsList, {
        prices,
        categories,
      }).length
    },
    // モーダルの編集中条件を一覧に反映し、確定状態として保持
    handleApplyFilters({ prices, categories }) {
      this.selectedPrices = [...prices]
      this.selectedCategories = [...categories]
      this.confirmedPrices = [...prices]
      this.confirmedCategories = [...categories]
      this.filterModalVisible = false
    },
    // 絞り込み条件を初期化
    resetFilters() {
      this.selectedPrices = []
      this.selectedCategories = []
      this.confirmedPrices = []
      this.confirmedCategories = []
      this.modalHitCount = this.allGoodsList.length
    },

    async fetchOptions() {
      this.listLoading = true

      const res = await this.$axios.$get('/option/options', {
        params: {
          month: this.month,
          cid: this.floor.id,
        },
      })

      this.listLoading = false

      const {
        startDate,
        endDate,
        catList,
        tips,
        floor,
        deliveryInfo,
        isAdmin,
        canRequest,
        warnTips,
        lastRequestDatetimeThisMonth,
        banners,
      } = res.data

      this.startDate = startDate
      this.endDate = endDate
      this.deliveryInfo = deliveryInfo
      this.isAdmin = isAdmin
      this.canRequest = canRequest
      this.warnTips = warnTips
      this.floor = floor
      this.lastRequestDatetimeThisMonth = lastRequestDatetimeThisMonth
      this.banners = banners?.map((item) => {
        item.link = item.link.includes('http')
          ? item.link
          : `${window.location.search}${item.link}`

        return item
      })

      const catListMap = {}

      catList.map((item) => {
        catListMap[item.catID] = item.goodsList.map((goods) => {
          goods.catID = item.catID

          if (!goods.count) {
            goods.count = 0
          }

          return goods
        })

        return item
      })

      this.catList = catList.slice()
      this.catListMap = catListMap
      this.tips = tips
    },
    goodsCountChange(item) {
      const index = this.catList.findIndex((cat) => cat.catID === item.catID)
      const catItem = this.catList[index]
      const goodsIndex = catItem.goodsList.findIndex(
        (goods) => goods.id === item.id
      )

      catItem.goodsList[goodsIndex].count = item.count

      this.$set(this.catList, index, catItem)
    },
    doSort(item) {
      if (this.sortActive !== item.name) {
        if (this.sortActive) {
          const lastSort = this.sorts.find(
            (sort) => sort.name === this.sortActive
          )

          if (lastSort) {
            lastSort.type = 'default'
          }
        }

        this.sortActive = item.name

        item.type = 'desc'
      } else {
        switch (item.type) {
          case 'default':
            item.type = 'desc'
            break
          case 'desc':
            item.type = 'asc'
            break
          case 'asc':
            item.type = 'default'
            this.sortActive = ''
            break
          default:
            break
        }
      }

      this.sortType = item.type
    },
    handleSort(data, key, type) {
      data.sort((a, b) => a[key] - b[key])

      if (type === 'desc') {
        data.reverse()
      }

      return data
    },
    resetAll() {
      this.catList = this.catList.map((item) => {
        item.goodsList = item.goodsList.map((goods) => {
          goods.count = 0

          return goods
        })

        return item
      })
    },
    async submit() {
      this.listLoading = true
      this.submitLoading = true

      const form = {
        month: this.month,
        cid: this.floor.id,
        catList: this.catList.map((cat) => {
          return {
            catID: cat.catID,
            goodsList: cat.goodsList.map((goods) => {
              return {
                id: goods.id,
                price: goods.price,
                count: goods.count,
              }
            }),
          }
        }),
        priceTotal: this.priceTotal,
        employeesPriceTotal: this.employeesPriceTotal,
        billingAmount: this.billingAmount,
      }

      const res = await this.$axios.post('/option/requests', form)

      this.listLoading = false
      this.submitLoading = false

      if (res.status !== 200) {
        return
      }

      this.$toast({
        message: '保存しました',
      })

      this.$router.push('/option/request-complete')
    },
  },
}
